const API_CONFIG = {
  BASE_URL: 'https://emiratesscholar.com/system/api',
  LOGIN_URL: 'https://emiratesscholar.com/system/api/login',
  SEND_VERIFICATION_EMAIL_URL: 'https://emiratesscholar.com/system/api/send-verification-email',
  USER_VERIFIED_URL: 'https://emiratesscholar.com/system/api/user_verified',
  UPDATE_USER_VERIFICATION_STATUS_URL: 'https://emiratesscholar.com/system/api/update-user-verification-status',
  FORGOT_PASSWORD_URL: 'https://emiratesscholar.com/system/api/forgot-password',
  VERIFY_RESET_OTP_URL: 'https://emiratesscholar.com/system/api/verify-reset-otp',
  RESET_PASSWORD_URL: 'https://emiratesscholar.com/system/api/reset-password',
};

export default API_CONFIG;